import script from "./LandingPageAirportTransfer.vue?vue&type=script&setup=true&lang=ts"
export * from "./LandingPageAirportTransfer.vue?vue&type=script&setup=true&lang=ts"

import "./LandingPageAirportTransfer.vue?vue&type=style&index=0&id=42bd0491&scoped=true&lang=css"
import "./LandingPageAirportTransfer.vue?vue&type=style&index=1&id=42bd0491&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-42bd0491"]])

export default __exports__